"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_SYNC_MAX_RETRY_COUNT = void 0;
/** Max automated retries for a FAILED `accounting_sync_idempotency` row (invoice or withdrawal). */
exports.ACCOUNTING_SYNC_MAX_RETRY_COUNT = 3;
